'use client';

import classNames from 'classnames';
import Ad from '@alltrails/ads/components/Ad/Ad';
import useUser from '@alltrails/context/hooks/useUser';
import Divider from '@/components/layouts/Divider/Divider';
import PageSection from '@/components/layouts/PageSection';
import styles from './AdPlacement.module.scss';

// https://www.figma.com/design/mGFBM8T5WalA5d44YLGV1I/Ads---sponsorships?node-id=320-52350&m=dev
export default function AdPlacement({ hasAlerts, trailDetails }) {
  const user = useUser();

  if (user?.featureEntitlements?.includes('ad_free')) {
    return null;
  }

  return (
    <div className={classNames(styles.container, { [styles.hasAlerts]: hasAlerts })}>
      <Divider />
      <PageSection hasDividerTop={false}>
        <Ad
          adUnitPath="/4689141/alltrails_trail_300x250"
          id="gpt-trail-ad-desktop-experiment"
          trail={trailDetails}
          lazyLoad
          adSize={[[728, 90]]}
          screenSize="desktop"
        />
        <Ad
          adUnitPath="/4689141/alltrails_trail_300x250"
          id="gpt-trail-ad-mobile-experiment"
          trail={trailDetails}
          lazyLoad
          adSize={[[300, 250]]}
          screenSize="mobile"
        />
      </PageSection>
      <Divider />
    </div>
  );
}
